export const SAGA_FETCH_DRIVES = "SAGA/FETCH_DRIVES";
export const SAGA_CHANGE_DRIVE_STATE = "SAGA/CHANGE_DRIVE_STATE";
export const SET_AGGREGATED = "SET_AGGREGATED";
